import { matchesPath } from '../matchesPath';

export const matchesProject = matchesPath<{ projectId: string }>(/\/project\/([^/]+)/, {
  projectId: 1
});
